import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// data
import { useBrand } from 'components/shared/SettingsProvider'

const ReupHeader = props => {
  const { season } = props
  const { name } = useBrand()

  return (
    <Box my={6}>
      <Typography variant='h1' align='center'>
        Register for {name} {season.year}
      </Typography>
    </Box>
  )
}

export default ReupHeader
